export default __webpack_public_path__ + "cd606ead609981091fac6ef29b9ed95d.gif";